import type { AvatarProps } from '../Avatar/Avatar';

import classes from './AvatarUser.module.css';
import Avatar from 'Components/UI_Library/Avatar';

export type Props = {
    /** The user object */
    user: AvatarProps['user'] & { email?: string; fullName?: string };
    /** Custom sizing of the avatar (height and width) */
    size?: string;
    /** Condition to check if the user data has loaded */
    loaded: boolean;
};

/** Renders the <Avatar> component along side the user name and email */
const AvatarUser = ({ user, size = '25', loaded }: Props) => {
    if (!loaded) return null;
    const userName = user?.fullName ?? `${user?.firstName || ''} ${user?.lastName || ''}`;
    return (
        <div className={classes.avatarUser}>
            <Avatar user={user} size={size} />
            <div>
                <p title={userName} className={classes.name}>
                    {userName}
                </p>
                {user?.email && <p className={classes.email}>{user.email}</p>}
            </div>
        </div>
    );
};

export default AvatarUser;
